(function (angular) {
	angular.module('bizPartEngage').controller('cleanbase.completeregister', completeRegister);

	completeRegister.$inject = [
		'$rootScope',
		'$scope',
		'$stateParams',
		'core.completeregisterService',
		'$translate',
		'$timeout',
		'$filter',
		'$sce',
		'core.users.service',
	];

	function completeRegister(
		$rootScope,
		$scope,
		$stateParams,
		completeRegisterService,
		$translate,
		$timeout,
		$filter,
		$sce,
		userService
	) {
		var vm = this;
		var customFieldRegexCache = {};

		vm.CompleteRegistrationGuid = $stateParams.guid;
		vm.Unauthorized = false;
		vm.MobileMandatory = $rootScope.MiniSettings.CompleteRegistration.MobileMandatory === true;

		vm.MobilePattern = /^\+[0-9]{10,}$/;
		vm.MobilePatternSE = /^\+460?7[0|2|3|6|9][0-9]{7}$/;

		vm.GetUser = GetUser;
		vm.CompleteRegistration = CompleteRegistration;
		vm.GenderClick = GenderClick;
		vm.GetGender = GetGender;
		vm.IsMobileValid = IsMobileValid;
		vm.LoadTranslations = LoadTranslations;
		vm.GetPassword = GetPassword;
		vm.IsEmailValid = IsEmailValid;
		vm.SendVerificationCode = SendVerificationCode;
		vm.IsPasswordSecure = IsPasswordSecure;

		vm.IsMainCustomField = IsMainCustomField;
		vm.IsPostCustomField = IsPostCustomField;
		vm.IsPostCustomFieldValid = IsPostCustomFieldValid;
		vm.IsUserCustomFieldInvalid = IsUserCustomFieldInvalid;
		vm.IsExtCustomFieldInvalid = IsExtCustomFieldInvalid;

		vm.UnitLogo = $rootScope.GetUnitSettingsImage();
		vm.ShowField = ShowField;
		vm.CustomFieldRegex = CustomFieldRegex;

		function ShowField(fieldKey) {
			if (!vm.User) return false;

			if (typeof CustomShowCompleteRegistrationFieldFn === 'function') {
				return CustomShowCompleteRegistrationFieldFn(fieldKey.toLowerCase(), vm.User);
			}

			var validDefaultFieldKeys = ['street', 'zip', 'city'];
			return (validDefaultFieldKeys.includes(fieldKey.toLowerCase()) && $rootScope.MiniSettings.CompleteRegistration['Show' + fieldKey] === true);
		}

		function CustomFieldRegex(customField) {
			var fieldRegex = customField && customField.Regex;
			var fieldKey = (customField && customField.SystemName ? customField.SystemName : '').toLowerCase();
			var cacheKey = fieldKey || ('id_' + (customField && customField.Id ? customField.Id : ''));

			if (customFieldRegexCache[cacheKey]) return customFieldRegexCache[cacheKey];

			if (typeof fieldRegex === 'string' && fieldRegex.length > 0) {
				customFieldRegexCache[cacheKey] = BuildCustomFieldRegex(fieldRegex);
				if (customFieldRegexCache[cacheKey]) {
					return customFieldRegexCache[cacheKey];
				}

					customFieldRegexCache[cacheKey] = /^.*$/;
					return customFieldRegexCache[cacheKey];
			}

			if (typeof CustomRegexCompleteRegistrationFieldFn === 'function') {
				var regex = CustomRegexCompleteRegistrationFieldFn(fieldKey);

				if (regex instanceof RegExp) {
					customFieldRegexCache[cacheKey] = regex;
					return regex;
				}

				if (typeof regex === 'string' && regex.length > 0) {
					customFieldRegexCache[cacheKey] = BuildCustomFieldRegex(regex);
					if (customFieldRegexCache[cacheKey]) {
						return customFieldRegexCache[cacheKey];
					}

						customFieldRegexCache[cacheKey] = /^.*$/;
						return customFieldRegexCache[cacheKey];
				}
			}

			customFieldRegexCache[cacheKey] = /^.*$/;
			return customFieldRegexCache[cacheKey];
		}

		function BuildCustomFieldRegex(regexValue) {
			var normalizedRegexValues = GetNormalizedRegexValues(regexValue);

			for (var i = 0; i < normalizedRegexValues.length; i++) {
				try {
					return new RegExp(normalizedRegexValues[i].pattern, normalizedRegexValues[i].flags);
				} catch (e) {
				}
			}

			return null;
		}

		function GetNormalizedRegexValues(regexValue) {
			if (typeof regexValue !== 'string') return [];

			var trimmedRegexValue = regexValue.trim();
			if (!trimmedRegexValue.length) return [];

			var normalizedValues = [];
			var regexLiteralMatch = trimmedRegexValue.match(/^\/(.*)\/([a-z]*)$/i);

			function addCandidate(pattern, flags) {
				if (typeof pattern !== 'string' || !pattern.length) return;

				for (var index = 0; index < normalizedValues.length; index++) {
					if (normalizedValues[index].pattern === pattern && normalizedValues[index].flags === (flags || '')) return;
				}

				normalizedValues.push({
					pattern: pattern,
					flags: flags || ''
				});
			}

			if (trimmedRegexValue.indexOf('\\\\') >= 0) {
				addCandidate(trimmedRegexValue.replace(/\\\\/g, '\\'));
			}

			if (regexLiteralMatch) {
				var literalPattern = regexLiteralMatch[1];
				if (literalPattern.indexOf('\\\\') >= 0) {
					addCandidate(literalPattern.replace(/\\\\/g, '\\'), regexLiteralMatch[2]);
				}

				addCandidate(literalPattern, regexLiteralMatch[2]);
			}

			addCandidate(trimmedRegexValue);

			return normalizedValues;
		}

		function IsUserCustomFieldInvalid(customField) {
			if (!customField) return false;

			var value = customField.Value && customField.Value.Value;
			var isMissingMandatoryValue = customField.IsMandatory && vm.ShowValidation && !value;
			var formFieldKey = 'cusfield_' + customField.Id;
			var hasPatternError = vm.MyForm && vm.MyForm[formFieldKey] && vm.MyForm[formFieldKey].$error.pattern;

			return isMissingMandatoryValue || hasPatternError;
		}

		function IsExtCustomFieldInvalid(customField) {
			if (!customField) return false;

			var value = vm.ExtCustomFieldValues && vm.ExtCustomFieldValues[customField.CustomId];
			var formFieldKey = 'extcusfield_' + customField.CustomId;
			var hasPatternError = vm.MyForm && vm.MyForm[formFieldKey] && vm.MyForm[formFieldKey].$error.pattern;
			var isMissingMandatoryValue = customField.IsMandatory && vm.ShowValidation && (value === undefined || value === null || value === '');

			return isMissingMandatoryValue || hasPatternError;
		}

		function IsPostCustomFieldValid(customField) {
			var formFieldKey = 'extcusfield_' + customField.CustomId;
			//any form errors - not valid
			if (vm.MyForm[formFieldKey] && vm.MyForm[formFieldKey].$error.pattern) return false;

			if (customField.IsMandatory) {
				//if mandatory and no value - not valid
				if (!vm.ExtCustomFieldValues || !vm.ExtCustomFieldValues[customField.CustomId]) return false;

				//if mandatory and options exist - valid if value is set
				if (customField.Options && customField.Options.length > 0) {
					return vm.ExtCustomFieldValues[customField.CustomId] !== undefined;
				}

				//if mandatory and no options and no value - not valid
				if (!vm.ExtCustomFieldValues[customField.CustomId].length) return false;
			}

			//if phone, mandatory check has already been done above, but we still need to check if the phone number is valid
			if (customField.CustomId.indexOf('PHONE') >= 0) {
				if (vm.CustomFieldsMobileBadInput && vm.CustomFieldsMobileBadInput[customField.CustomId]) return false;

				if (
					vm.ExtCustomFieldValues[customField.CustomId] &&
					!vm.IsMobileValid(vm.ExtCustomFieldValues[customField.CustomId], true)
				)
					return false;
			}

			return true;
		}

		function IsMainCustomField(field) {
			return field.CustomId.toLowerCase().startsWith('postfield_') === false;
		}

		function IsPostCustomField(field) {
			return field.CustomId.toLowerCase().startsWith('postfield_') === true;
		}

		function IsEmailValid() {
			if (!vm.User || !vm.User.Email) return false;
			if (!vm.EmailPattern) return true;

			return vm.EmailPattern.test(vm.User.Email);
		}

		function SendVerificationCode() {
			if (vm.IsEmailValid()) {
				completeRegisterService
					.SendVerificationCode(vm.CompleteRegistrationGuid, vm.User.Email)
					.then(SendVerificationCodeCallback, SendVerificationCodeError);
			} else {
				vm.ShowEmailInvalid = true;
			}

			function SendVerificationCodeCallback(response) {
				var result = BizPartCoreHelpers.getResponseValue(response);
				if (result) {
					vm.VerificationCodeSent = true;
				} else {
					SendVerificationCodeError();
				}
			}

			function SendVerificationCodeError() {
				console.log('send verification code error');
			}
		}

		function IsMobileValid(number, skipSeMatch) {
			if (!number) return false;

			if (number.startsWith('+46') && vm.MobilePatternSE && !skipSeMatch) {
				return vm.MobilePatternSE.test(number);
			} else {
				return vm.MobilePattern.test(number);
			}
		}

		function GenderClick(gender) {
			for (var i = 0; i < vm.Genders.length; i++) {
				vm.Genders[i].checked = vm.Genders[i] === gender;
			}
		}

		function GetUser() {
			if (vm.CompleteRegistrationGuid == 'test') {
				var result = {
					User: {
						Email: 'test@test.se',
						FirstName: 'Test',
						LastName: 'Testsson',
						Mobile: '+46701234567',
						Roles: [{ SystemName: 'LH_HOMEWORK_HELPER'}]
					},
					Settings: {},
				};

				vm.User = result.User;
				InitFormSettings(result.Settings);
				vm.Initialized = true;
				return;
			}

			completeRegisterService
				.GetUserByActionGuid(vm.CompleteRegistrationGuid)
				.then(GetUserByActionGuidCallback, HandleError);

			function GetUserByActionGuidCallback(response) {
				var result = BizPartCoreHelpers.getResponseValue(response);
				vm.User = result.User;
				InitFormSettings(result.Settings);
				CustomGenderFilter();
				vm.Initialized = true;
			}

			function HandleError(response) {
				if (response.status === 401) {
					vm.Unauthorized = true;
					vm.UnauthorizedMessage = BizPartCoreHelpers.getResponseValue(response);
				}
			}
		}

		function GetGender() {
			for (var i = 0; i < vm.Genders.length; i++) {
				if (vm.Genders[i].checked) {
					return vm.Genders[i].SystemName;
				}
			}
			return null;
		}

		function IsPasswordSecure() {
			return !vm.GetPassword || $rootScope.PasswordRegex.test(vm.Password);
		}

		function GetPassword() {
			if (vm.IsPasswordSecure() && vm.Password && vm.Password === vm.RepeatPassword) {
				return vm.Password;
			}
		}

		function CompleteRegistration() {
			var gender = vm.GetGender();

			var password;
			var passwordValid = true;
			if (vm.FormSettings && vm.FormSettings.AllowSetPassword) {
				password = vm.GetPassword();
				if (!password) {
					passwordValid = false;
				}
			}

			var isMobileEmptyAndNotMandatory = !vm.MobileMandatory && vm.MobileBadInput;
			var mobileValid = isMobileEmptyAndNotMandatory || (vm.IsMobileValid(vm.User.Mobile) && !vm.MobileBadInput);
			if (isMobileEmptyAndNotMandatory) {
				vm.User.Mobile = ''; //might have country prefix
			}

			var postExtFieldsValid = true;
			if (vm.FormSettings.ExtCustomFields) {
				for (var i = 0; i < vm.FormSettings.ExtCustomFields.length; i++) {
					var customField = vm.FormSettings.ExtCustomFields[i];
					//just check post fields because I dont want to risk messing up the other ones
					if (IsPostCustomField(customField) && !IsPostCustomFieldValid(customField)) {
						postExtFieldsValid = false;
						break;
					}
				}
			}

			if (
				vm.MyForm.$valid &&
				gender &&
				passwordValid &&
				mobileValid &&
				!vm.Submitting &&
				!vm.Submitted &&
				postExtFieldsValid
			) {
				var extCustomFieldValues;
				if (vm.ExtCustomFieldValues) {
					extCustomFieldValues = angular.copy(vm.ExtCustomFieldValues);

					for (var customId in extCustomFieldValues) {
						if (extCustomFieldValues.hasOwnProperty(customId)) {
							var item = extCustomFieldValues[customId];
							if (item && (item.Value || item.Value === '')) {
								extCustomFieldValues[customId] = item.Value;
							}
						}
					}
				}

				console.log('submitted', extCustomFieldValues);
				vm.ShowValidation = false;
				vm.Submitting = true;

				vm.User.Gender = gender;

				completeRegisterService
					.CompleteRegistration(
						vm.CompleteRegistrationGuid,
						vm.User,
						password,
						extCustomFieldValues,
						vm.VerificationCode
					)
					.then(CompleteRegistrationCallback, HandleError);

				function CompleteRegistrationCallback(response) {
					var result = BizPartCoreHelpers.getResponseValue(response);
					console.log('result', result);
					vm.Submitted = true;
					vm.Success = result.Success;
					if (!vm.Success) {
						vm.Message = $sce.trustAsHtml(result.Message);
					} else {
						vm.SuccessMessage = $sce.trustAsHtml(result.Message);
						var redirectUrl = result.ExtraInfo.RedirectUrl;
						if (redirectUrl) {
							if (redirectUrl.startsWith('/') && redirectUrl.toLowerCase().indexOf('login') < 0) {
								setSessionStorage('highlightLogin', 'true');
							}

							vm.RedirectTimeout = $timeout(() => {
								location.href = $filter('siteroot')(redirectUrl);
							}, 20000);
						}
					}
				}

				function HandleError() {
					console.log('handle error');
					vm.Success = false;
					vm.Submitted = true;
					vm.InternalError = true;
					vm.Message = 'Something went wrong, please try again later.';
				}
			} else {
				console.log('not valid');
				vm.ShowValidation = true;
			}
		}

		function LoadTranslations() {
			$translate(['CORE.COMPLETEREGISTER.ERROR_MSG', 'CORE.COMPLETEREGISTER.MAILTO']).then(function (translations) {
				var msg = translations['CORE.COMPLETEREGISTER.ERROR_MSG']?.toString();
				var mail = translations['CORE.COMPLETEREGISTER.MAILTO']?.toString();
				if (msg && mail) {
					vm.ErrorMessage = msg.replace('##MAILTOLINK##', '<a href="mailto:' + mail + '">' + mail + '</a>');
				} else {
					vm.ErrorMessage = msg;
				}
				console.log('error msg', vm.ErrorMessage);
			});
		}

		function InitFormSettings(settings) {
			if (settings && settings.ExtCustomFields) {
				for (var i = 0; i < settings.ExtCustomFields.length; i++) {
					if (settings.ExtCustomFields[i].Options?.length > 0) {
						var options = settings.ExtCustomFields[i].Options;
						for (var j = 0; j < options.length; j++) {
							options[j].Id = options[j].Value;
						}
					}

					if (IsPostCustomField(settings.ExtCustomFields[i])) {
						vm.HasPostCustomFields = true;
					}
				}
			}
			vm.FormSettings = settings;
			console.log('vm.FormSettings', vm.FormSettings);
		}

		function CustomGenderFilter() {
			if ($rootScope.MiniSettings['Profile'].CustomGenderFilterFn && vm.Genders && vm.User) {
				console.log('vm.Genders', vm.Genders);
				vm.Genders = $rootScope.MiniSettings['Profile'].CustomGenderFilterFn(vm.Genders, vm.User);
			}
		}

		function Init() {
			userService.GetGenders().then(GetGendersCallback);
			vm.LoadTranslations();
			if (vm.CompleteRegistrationGuid == 'test') {
				vm.GetUser();
				return;
			}
			completeRegisterService.GetGuidInfo(vm.CompleteRegistrationGuid).then(GetGuidInfoCallback, HandleError);

			function GetGuidInfoCallback(response) {
				var result = BizPartCoreHelpers.getResponseValue(response);
				console.log('GetGuidInfoCallback', result);
				if (result.Type === 'COMPLETE_REGISTRATION') {
					vm.GetUser();
				} else if (result.Type === 'CREATE_USER_FOR_UNIT') {
					vm.CreateUserForUnit = true;
					InitFormSettings(result.Settings);

					if (vm.FormSettings.AllowEmailDomains && vm.FormSettings.AllowEmailDomains.length > 0) {
						var regexDomains = vm.FormSettings.AllowEmailDomains.join('|');
						//vm.EmailPattern = new RegExp("^\\w+([-+.']\\w+)*@(?=(?:" + regexDomains + ")\\.\\w+$)\\w+([-.]\\w+)*\\.\\w+([-.]\\w+)*$");
						vm.EmailPattern = new RegExp('^[a-zA-Z0-9._%+-]+@(?:' + regexDomains + ')$');
					}

					vm.Initialized = true;
				}
			}

			function HandleError(response) {
				if (response.status === 401) {
					vm.Unauthorized = true;
					vm.UnauthorizedMessage = BizPartCoreHelpers.getResponseValue(response);
				}
			}

			function GetGendersCallback(response) {
				var genders = BizPartCoreHelpers.getResponseValue(response);
				vm.Genders = genders.filter((g) => g.SystemName !== 'OTHER');

				CustomGenderFilter();
			}

			$scope.$on('$destroy', () => {
				if (vm.RedirectTimeout) {
					$timeout.cancel(vm.RedirectTimeout);
				}
			});
		}

		vm.$onInit = Init;
	}
})(window.angular);
